import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import * as _descope_core_js_sdk from '@descope/core-js-sdk';

import { Ampli, ampli, EventOptions, IdentifyProperties, PromiseResult, Result } from '@/ampli';
import { Analytics, AnalyticsUser, getVoidPromiseResult } from './analytics.interface';

export class AmplitudeAnalytics implements Analytics {
    apiKey: string
    isInitialized: boolean = false
    ampliInstance: Ampli = process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'production' ? ampli : new Ampli();

    constructor(apiKey: string) {
        this.apiKey = process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'production' ? apiKey : 'dev'
    }

    async initialize() {
        if (!this.isInitialized) {
            await this.ampliInstance.load({
                client: {
                    apiKey: this.apiKey,
                    configuration: {
                        defaultTracking: {
                            sessions: process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'production',
                        }
                    }
                },
                environment: 'clearitty',
            })

            // Create and Install Session Replay Plugin
            const sessionReplayTracking = sessionReplayPlugin({ sampleRate: 1 });
            this.ampliInstance.client?.add(sessionReplayTracking);

            this.isInitialized = true
        }
    }

    identify(userId: string | undefined, properties?: IdentifyProperties, options?: EventOptions): PromiseResult<Result> {
        const isProd = process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'production';
        if (isProd) {
            if (!this.isInitialized) {
                this.initialize();
            }

            if (!userId) {
                console.warn('User id is missing', userId)
            }

            if (!properties || !properties.email) {
                console.warn('User email is missing', properties)
            }

            if (!properties || !properties.name) {
                console.warn('User name is missing', properties)
            }

            return this.ampliInstance.identify(userId || 'N/A', {
                email: properties?.email || '',
                name: properties?.name || 'N/A',
                anonEmail: properties?.anonEmail || 'N/A',
            });
        } else {
            return getVoidPromiseResult();
        }
    }

    getTrackerInstance() {
        return this.ampliInstance;
    }
}